module.exports = __webpack_public_path__ + "static/media/westernpostform.f6d115b5.png";